export const constant = {
    // 企業画面用のコンフィグファイル
    // WebAPI URL(1)
    BASE_API_URL_S: '/ms',
    // WebAPI URL(2)
    BASE_API_URL_P: '/mp',
    // ユーザープールID
    USER_POOL_ID: 'ap-northeast-1_2hyXJonmt',
    // クライアントID 通常ログイン用
    CLIENT_ID_1: '19rk9qev39mvjrail6febqeiqf',
    // クライアントID SSOログイン用
    CLIENT_ID_2: '7qu8q8jqgssa4jbodu88gmlbbq',
    // CognitoでのSSOログイン用Key
    COGNITO_KEY: '1lspk79q8ec12dmo56le3qui8bbirmp4cbtd287lqh11eg711tmi',
    // CognitoでのSSOリダイレクト先URL
    COGNITO_AUTH_URL: 'armcng-userpool-cmp01.auth.ap-northeast-1.amazoncognito.com',
    // CognitoサインアウトエンドポイントのURL
    COGNITO_SIGNOUT_ENDPOINT_URL: 'https://armcng-userpool-cmp01.auth.ap-northeast-1.amazoncognito.com/logout',
};
